import {Component, OnDestroy, OnInit} from '@angular/core';
import {IconComponent} from '../../elements/icon/icon.component';
import {Icons} from '../../../model/icon';
import {MenuService} from '../../../services/menu-services';
import {ThemeService} from '../../../services/theme.service';
import {HeaderService} from '../../../services/header-service';
import {scrollUp} from '../../../functions/scroll-up';
import {HotelService} from '../../../services/hotel-service';
import {ScrollService} from '../../../services/scroll-service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {NgIf} from '@angular/common';
import {RouteService} from '../../../services/route-service';
import {NavigationService} from '../../../services/navigation-service';

@Component({
  selector: 'app-map-page',
  imports: [
    IconComponent,
    NgIf,
  ],
  templateUrl: './map-page.component.html',
  styleUrl: './map-page.component.scss'
})
export class MapPageComponent implements OnInit, OnDestroy {
  constructor(protected menuService: MenuService,
              protected themeService: ThemeService,
              protected interfaceService: HeaderService,
              protected hotelService: HotelService,
              private scroll: ScrollService,
              private sanitizer: DomSanitizer,
              protected routeService: RouteService,
              public navigationService: NavigationService) {}

  mapId: string | undefined = undefined;
  private cachedMapUrl: SafeResourceUrl | null = null;


  ngOnInit() {
    this.mapId = this.routeService.getMapId();
    scrollUp();
    setTimeout(() => {
      this.scroll.lockScroll();
    }, 350);
  }

  ngOnDestroy() {
    this.scroll.unlockScroll();
  }

  getInvert() {
    if (this.menuService.getActive()) {
      return this.themeService.getTheme() != 'black-theme';
    } else {
      if (this.themeService.getTheme() == 'black-theme') {
        return false
      } else {
        return this.interfaceService.getActiveInterface() != 'header-transparent'
      }
    }
  }

  up() {
    scrollUp();
    this.scroll.unlockScroll();
    this.hotelService.setActiveInterface(0);
  }

  getSafeMapUrl(mapId?: string): SafeResourceUrl {
    const id = mapId || this.mapId;
    if (this.cachedMapUrl && id === this.mapId) {
      return this.cachedMapUrl;
    }
    const url = `https://snazzymaps.com/embed/${id}`;
    this.cachedMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    return this.cachedMapUrl;
  }


  protected readonly Icons = Icons;
}
